document.addEventListener('DOMContentLoaded', function () {
  // Flag to track when adding from order now page
  let isAddingFromOrderNow = false;

  // Get cart type setting (drawer or page)
  const cartType = window.cartType || 'drawer';

  // Intercept theme's cart:added event to handle based on cart type setting
  document.addEventListener('theme:cart:added', function(e) {
    if (isAddingFromOrderNow) {
      // If cart type is 'page', redirect to cart page
      if (cartType === 'page') {
        e.stopImmediatePropagation(); // Prevent any drawer behavior
        window.location = '/cart';
      }
      // If cart type is 'drawer', let theme's default drawer behavior happen
      // (no action needed - theme will open drawer automatically)
    }
  }, true); // Use capture phase to intercept before theme's handler

  // Retrieve product JSONs from the Liquid script
  let currentMonthProduct = window.currentMonthProduct;
  let nextMonthProduct = window.nextMonthProduct;
  let currentMonthSeasonalProduct = window.currentMonthSeasonalProduct;
  let nextMonthSeasonalProduct = window.nextMonthSeasonalProduct;
  let currentMonthProductDefault = window.currentMonthProductDefault;
  let nextMonthProductDefault = window.nextMonthProductDefault;

  // Log the product JSONs to the console
  console.log('Current Month Product JSON:', currentMonthProduct);
  console.log('Next Month Product JSON:', nextMonthProduct);
  console.log('Current Month Seasonal Product JSON:', currentMonthSeasonalProduct);
  console.log('Next Month Seasonal Product JSON:', nextMonthSeasonalProduct);

  let selectedProductId = null;
  let selectedMenuOption = null;
  let selectedVariant = null;

  const orderNowSection = document.getElementById('order-now-section');
  const progressBarContainer = document.querySelector('.order-progress-bar-container');
  const productPart = document.getElementById('product-part');
  const cartPart = document.getElementById('cart-part');
  let menuOptions = document.getElementById('menu-options');
  let sizeOptions = document.getElementById('size-options');
  let progressBarSteps = document.querySelectorAll('.order-progress-step');
  let addToCartForm = document.getElementById('order-now-form');
  let addToCartButton = document.getElementById('order-now-add-to-cart');
  let frequencyLabel = document.getElementById('frequency-label');
  let frequencySubheading = document.getElementById('frequency-subheading');
  let orderNowFormSubscription = document.getElementById('order-now-form-subscription');

  orderNowFormSubscription.addEventListener('click', function () {
    // Check if the clicked element is an input
    updateProgressBar(3);
  });

  // Arrow-key navigation for menu tabs (tablist pattern)
  menuOptions.addEventListener('keydown', function (e) {
    const tab = e.target.closest('.menu-option-card');
    if (!tab || tab.getAttribute('role') !== 'tab') return;
    const tabs = menuOptions.querySelectorAll('.menu-option-card[role="tab"]');
    const idx = Array.from(tabs).indexOf(tab);
    if (idx === -1) return;
    let nextIdx = -1;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      nextIdx = (idx + 1) % tabs.length;
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      nextIdx = (idx - 1 + tabs.length) % tabs.length;
    }
    if (nextIdx !== -1) {
      e.preventDefault();
      tabs[nextIdx].focus();
      tabs[nextIdx].click();
    }
  });

  // Function to initialize the page
  function initializePage() {
    let initialProduct = currentMonthProduct;
    let initialSeasonalProduct = currentMonthSeasonalProduct;
    let month = 'current';
    if (nextMonthProductDefault) {
      initialProduct = nextMonthProduct;
      initialSeasonalProduct = nextMonthSeasonalProduct;
      month = 'next';
    }
    if (currentMonthProductDefault) {
      initialProduct = currentMonthProduct;
      initialSeasonalProduct = currentMonthSeasonalProduct;
    }
    // Populate the menu selector and display variants
    populateMenuSelector(initialProduct, initialSeasonalProduct, month);
    displayVariants(initialProduct.id, initialProduct ? initialProduct.variants[0].option1 : '');
    updateProgressBar(1);
    updateFrequencyLabel(initialProduct);

    addToCartForm.addEventListener('submit', handleAddToCart);

    document.querySelectorAll('.cart__item__remove').forEach((button) => {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        const lineItemId = button.getAttribute('data-id');
        removeCartItem(lineItemId);
      });
    });

    if (!currentMonthProductDefault && nextMonthProductDefault) {
      document.getElementById('current-month-btn').classList.remove('active');
      document.getElementById('next-month-btn').classList.add('active');
    }
  }

  function toggleMenuInfoShow(activeId) {
    let menuContentGridRow = 0;
    const menuOptionCard = document.querySelector(`.${activeId}-card`);

    const index = Array.from(menuOptionCard.parentNode.children).indexOf(menuOptionCard);
    menuContentGridRow = Math.floor(index / 2) + 2;

    showMenuDetails(activeId, menuContentGridRow);
  }

  function showMenuDetails(id, gridRowStart) {
    hideMenuDetails();
    const original = document.querySelector(`.menu-details-placeholder #${id}.text`);
    if (!original) return;

    const copy = original.cloneNode(true); // Deep copy

    const container = document.createElement('div');
    container.className = 'menu-details-container';
    container.id = `menu-details-${id}`;
    container.setAttribute('role', 'tabpanel');
    container.setAttribute('aria-labelledby', `${id}-tab`);
    container.setAttribute('tabindex', '0');
    container.style.gridRowStart = gridRowStart;

    const menuOptions = document.getElementById('menu-options');
    if (!menuOptions) return;

    container.appendChild(copy);
    menuOptions.appendChild(container);
    // Move focus to the panel so screen readers announce the selected tab content
    requestAnimationFrame(function () {
      container.focus({ preventScroll: true });
    });
  }

  function hideMenuDetails() {
    const container = document.querySelector(`.menu-details-container`);
    if (container) {
      container.remove();
    }
  }

  // Map variant option1 to menu detail panel slug (matches order-now-menu-info snippet IDs)
  function getMenuDetailSlug(option1) {
    if (!option1) return option1;
    const normalized = option1.trim();
    if (normalized === 'Classic Menu' || normalized === 'Family Style') return 'family-style';
    if (normalized === 'Gluten-Free') return 'gluten-free';
    if (normalized === 'Protein+' || normalized === 'Macro-Balanced') return 'macro-balanced';
    return normalized.toLowerCase().replace(/\s+/g, '-');
  }

  // Display label for menu option (e.g. "Family Style or Classic Menu" for Classic Menu)
  function getMenuDisplayLabel(option1) {
    if (!option1) return option1;
    const normalized = option1.trim();
    if (normalized === 'Classic Menu') return 'Classic Menu';
    return option1;
  }

  function populateMenuSelector(product, seasonalProduct, month) {
    menuOptions.innerHTML = '';
    let uniqueOptions1 = [];
    let firstMenuCard = true;
    (product.variants || []).forEach(function (variant) {
      if (!uniqueOptions1.includes(variant.option1)) {
        uniqueOptions1.push(variant.option1);

        // Create the card container (tab pattern: screen reader moves to tabpanel on select)
        let menuCard = document.createElement('div');
        menuCard.classList.add('menu-option-card');
        menuCard.setAttribute('role', 'tab');
        // All tabs in tab order so users can Tab between menu options (not only roving tabindex + arrows)
        menuCard.setAttribute('tabindex', '0');
        menuCard.setAttribute('aria-selected', firstMenuCard ? 'true' : 'false');
        menuCard.setAttribute('aria-label', getMenuDisplayLabel(variant.option1));

        menuCard.innerHTML = `
          <svg class="svg" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <circle cx="10.5" cy="10.5" r="10" fill="#FBD401" stroke="black"/>
            <path d="M5.97168 11.4451L9.50002 14.7609L14.8138 6.47144" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        `;

        // Map option1 to content panel slug so Classic Menu → family-style, Protein+ → macro-balanced
        const detailSlug = getMenuDetailSlug(variant.option1);
        const textId = `${month}-${detailSlug}`;
        const displayLabel = getMenuDisplayLabel(variant.option1);

        // Create image element
        let img = document.createElement('img');
        img.src = variant.featured_image ? variant.featured_image.src : '';
        img.alt = '';

        // Create overlay element
        let overlay = document.createElement('div');
        overlay.classList.add('overlay');

        // Create text element
        let span = document.createElement('span');
        span.textContent = displayLabel;

        // Append image and text to the card
        menuCard.appendChild(img);
        menuCard.appendChild(overlay);
        menuCard.appendChild(span);
        menuCard.setAttribute('data-option1', variant.option1);
        menuCard.setAttribute('id', `${textId}-tab`);
        menuCard.setAttribute('aria-controls', `menu-details-${textId}`);
        menuCard.classList.add(`${textId}-card`);

        if (firstMenuCard) {
          menuCard.classList.add('active');
          firstMenuCard = false; // Ensure this only happens for the first card

          const firstTextId = textId;

          setTimeout(() => {
            toggleMenuInfoShow(firstTextId);
          }, 0);
        }

        function handleMenuCardSelect() {
          toggleMenuInfoShow(textId);
          removeActiveClass('menu-option-card');
          menuCard.classList.add('active');
          document.querySelectorAll('.menu-option-card').forEach(function (c) {
            c.setAttribute('aria-selected', c === menuCard ? 'true' : 'false');
          });
          const prevSelectedProductId = selectedProductId;
          displayVariants(product.id, variant.option1);
          if (prevSelectedProductId !== product.id) {
            initRechargeWidget(product);
            updateFrequencyLabel(product);
          }
          updateProgressBar(1);
        }

        menuCard.addEventListener('click', handleMenuCardSelect);
        menuCard.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleMenuCardSelect();
          }
        });

        menuOptions.appendChild(menuCard);
      }
    });
    if (seasonalProduct && seasonalProduct.id) {
      // Create the card container (tab pattern: screen reader moves to tabpanel on select)
      let menuCard = document.createElement('div');
      menuCard.classList.add('menu-option-card');
      menuCard.setAttribute('role', 'tab');
      menuCard.setAttribute('tabindex', '0');
      menuCard.setAttribute('aria-selected', 'false');
      menuCard.setAttribute('aria-label', seasonalProduct.title);

      menuCard.innerHTML = `
        <svg class="svg" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <circle cx="10.5" cy="10.5" r="10" fill="#FBD401" stroke="black"/>
          <path d="M5.97168 11.4451L9.50002 14.7609L14.8138 6.47144" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `;

      // Create info icon element
      const textId = `${month}-soup-menu`;
      menuCard.setAttribute('id', `${textId}-tab`);
      menuCard.setAttribute('aria-controls', `menu-details-${textId}`);

      // Create image element
      let img = document.createElement('img');
      img.src = seasonalProduct.featured_image ? seasonalProduct.featured_image : '';
      img.alt = '';

      // Create overlay element
      let overlay = document.createElement('div');
      overlay.classList.add('overlay');

      // Create text element
      let span = document.createElement('span');
      span.textContent = seasonalProduct.title;

      // Append image and text to the card
      menuCard.appendChild(img);
      menuCard.appendChild(overlay);
      menuCard.appendChild(span);
      menuCard.setAttribute('data-option1', seasonalProduct.title);
      menuCard.classList.add(`${textId}-card`);

      function handleSeasonalCardSelect() {
        toggleMenuInfoShow(textId);
        removeActiveClass('menu-option-card');
        menuCard.classList.add('active');
        document.querySelectorAll('.menu-option-card').forEach(function (c) {
          c.setAttribute('aria-selected', c === menuCard ? 'true' : 'false');
        });
        displaySizeVariants(seasonalProduct.id);
        updateFrequencyLabel(seasonalProduct);
        updateProgressBar(1);
        let widgetContainer = document.getElementById('order-now-form-subscription');
        widgetContainer.innerHTML = '';
      }

      menuCard.addEventListener('click', handleSeasonalCardSelect);
      menuCard.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleSeasonalCardSelect();
        }
      });

      menuOptions.appendChild(menuCard);
    }
  }

  // Function to display size variants initially without menu option
  function displayVariants(productId, menuOption) {
    if (selectedProductId !== productId || selectedMenuOption !== menuOption) {
      selectedProductId = productId;
      selectedMenuOption = menuOption;

      sizeOptions.innerHTML = '';
      const product = selectedProductId === currentMonthProduct.id ? currentMonthProduct : nextMonthProduct;

      const matchedVariants = (product.variants || []).filter((variant) => {
        return variant.option1 === menuOption;
      });

      if (matchedVariants.length > 0) {
        selectedVariant = matchedVariants[0];

        matchedVariants.forEach((variant, index) => {
          const servingsMatch = variant.option2.match(/(\d+)\s*-\s*(\d+)/i);
          const servingsText = servingsMatch ? `${servingsMatch[1]}-${servingsMatch[2]} servings` : variant.option2;
          const maxServings = servingsMatch ? parseInt(servingsMatch[2]) : 1;
          const oneTimePricePerServing = (variant.price / 100 / 10 / maxServings).toFixed(2);

          // Calculate subscription price per serving
          let subscriptionPricePerServing = null;
          if (variant.selling_plan_allocations && variant.selling_plan_allocations.length > 0) {
            // Use the first selling plan allocation (or pick the correct one if needed)
            const subPrice = variant.selling_plan_allocations[0].price;
            subscriptionPricePerServing = (subPrice / 100 / 10 / maxServings).toFixed(2);
          }

          // Create one-time price container
          const oneTimePriceContainer = document.createElement('div');
          oneTimePriceContainer.className = `servings-price-container one-time ${
            subscriptionPricePerServing ? 'hidden' : ''
          }`;
          oneTimePriceContainer.innerHTML = `
            <p class="servings-text yotpo-subscription-policy-text-main cerebri-regular">${servingsText}</p>
            <p class="price-text yotpo-subscription-policy-text-main cerebri-regular">$${oneTimePricePerServing}/serving</p>
          `;

          // Create subscription price container
          let subscriptionPriceContainer = null;
          if (subscriptionPricePerServing !== null) {
            subscriptionPriceContainer = document.createElement('div');
            subscriptionPriceContainer.className = 'servings-price-container subscription';
            subscriptionPriceContainer.innerHTML = `
              <p class="servings-text yotpo-subscription-policy-text-main cerebri-regular">${servingsText}</p>
              <p class="price-text yotpo-subscription-policy-text-main cerebri-regular">$${subscriptionPricePerServing}/serving</p>
            `;
          }

          // Create size card
          const sizeCard = document.createElement('div');
          sizeCard.className = 'size-option-card';

          // Create radio, title and price container
          const radioTitleContainer = document.createElement('div');
          radioTitleContainer.className = 'radio-title-container';
          const sizeLabel = (variant.option2 || '').replace(/"/g, '&quot;');
          radioTitleContainer.innerHTML = `
            <input type="radio" name="size-option" id="size-${variant.id}" value="${variant.id}" aria-label="${sizeLabel}" ${
            index === 0 ? 'checked' : ''
          }>
            <label for="size-${variant.id}" class="custom-radio"></label>
            <div class="title-price-wrapper">
              <span class="cerebri-regular">${variant.option2}</span>
            </div>
          `;

          const wrapper = radioTitleContainer.querySelector('.title-price-wrapper');
          if (wrapper) {
            wrapper.appendChild(oneTimePriceContainer);
            if (subscriptionPriceContainer) {
              wrapper.appendChild(subscriptionPriceContainer);
            }
          }

          sizeCard.appendChild(radioTitleContainer);

          if (index === 0) {
            sizeCard.classList.add('active');
            // Add serving note for initially selected variant
            const note = document.createElement('div');
            note.className = 'serving-note';
            let template = window.servingNoteTemplate || `You will receive ${servingsText} of each freezer meal on the menu.`;
            if (template.includes('{placeholder}')) {
              note.textContent = template.replace('{placeholder}', servingsText);
            } else {
              note.textContent = template;
            }
            sizeCard.appendChild(note);
          }

          sizeCard.addEventListener('click', () => {
            selectedVariant = variant;
            document.querySelectorAll('.size-option-card').forEach((c) => {
              c.classList.remove('active');
              c.querySelector('.serving-note')?.remove();
            });

            sizeCard.classList.add('active');
            const note = document.createElement('div');
            note.className = 'serving-note';
            let template = window.servingNoteTemplate || `You will receive ${servingsText} of each freezer meal on the menu.`;
            if (template.includes('{placeholder}')) {
              note.textContent = template.replace('{placeholder}', servingsText);
            } else {
              note.textContent = template;
            }
            sizeCard.appendChild(note);

            updateAddToCartButtonState(variant.available);
            updateProgressBar(2);
            updateRechargeWidget(variant);
          });

          sizeOptions.appendChild(sizeCard);
        });

        updateAddToCartButtonState(matchedVariants[0].available);
        updateRechargeWidget(matchedVariants[0]);
      }
    }
  }

  function displaySizeVariants(productId) {
    if (selectedProductId !== productId) {
      selectedProductId = productId;

      sizeOptions.innerHTML = '';
      let product =
        selectedProductId === currentMonthSeasonalProduct.id ? currentMonthSeasonalProduct : nextMonthSeasonalProduct;

      const matchedVariants = product.variants || [];

      if (matchedVariants.length > 0) {
        selectedVariant = matchedVariants[0];

        matchedVariants.forEach((variant, index) => {
          // Create size card
          const sizeCard = document.createElement('div');
          sizeCard.className = 'size-option-card';

          const titleContent =
            variant.option1 === 'Default Title' && defaultTitleReplace ? defaultTitleReplace : variant.option1;

          // Create radio, title and price container
          const radioTitleContainer = document.createElement('div');
          radioTitleContainer.className = 'radio-title-container';
          radioTitleContainer.innerHTML = `
            <input type="radio" name="size-option" id="size-${variant.id}" value="${variant.id}" aria-label="${titleContent.replace(/"/g, '&quot;')}" ${
            index === 0 ? 'checked' : ''
          }>
            <label for="size-${variant.id}" class="custom-radio"></label>
            <div class="title-price-wrapper">
              <span class="cerebri-regular">${titleContent}</span>
            </div>
          `;

          let priceWrapper = document.createElement('div');
          let price = document.createElement('p');
          price.textContent = `$${(variant.price / 100).toFixed(2)}`;
          priceWrapper.appendChild(price);
          if (variant.compare_at_price) {
            // Add compare at price conditionally
            let compareAtPrice = document.createElement('p');
            compareAtPrice.textContent = `($${(variant.compare_at_price / 100).toFixed(2)})`;
            compareAtPrice.style.textDecoration = 'line-through';
            compareAtPrice.style.color = '#888';
            compareAtPrice.style.marginLeft = '5px';
            priceWrapper.appendChild(compareAtPrice);
          }
          priceWrapper.classList.add('price-text');
          priceWrapper.classList.add('yotpo-subscription-policy-text-main');
          priceWrapper.classList.add('cerebri-regular');

          let priceContainer = document.createElement('div');
          priceContainer.classList.add('servings-price-container');
          priceContainer.appendChild(priceWrapper);

          sizeCard.appendChild(radioTitleContainer);
          if (product.selling_plan_groups.length === 0) {
            const wrapper = sizeCard.querySelector('.title-price-wrapper');
            if (wrapper) {
              wrapper.appendChild(priceContainer);
            }
          }

          if (index === 0) {
            sizeCard.classList.add('active');
          }

          sizeCard.addEventListener('click', () => {
            selectedVariant = variant;
            document.querySelectorAll('.size-option-card').forEach((c) => {
              c.classList.remove('active');
            });

            sizeCard.classList.add('active');

            updateAddToCartButtonState(variant.available);
            updateProgressBar(2);
            updateRechargeWidget(variant);
          });

          sizeOptions.appendChild(sizeCard);
        });

        updateAddToCartButtonState(matchedVariants[0].available);
        updateRechargeWidget(matchedVariants[0]);
      }
    }
  }

  // Function to remove the active class from all elements of a given class
  function removeActiveClass(className) {
    let elements = document.getElementsByClassName(className);
    Array.from(elements).forEach(function (element) {
      element.classList.remove('active');
    });
  }

  // Function to update the "Add to Cart" button state based on variant availability
  function updateAddToCartButtonState(isAvailable) {
    if (isAvailable) {
      addToCartButton.disabled = false;
      addToCartButton.innerText = 'Add to cart';
    } else {
      addToCartButton.disabled = true;
      addToCartButton.innerText = 'Sold out';
    }
  }

  // Function to show/hide frequency label based on selling plans
  function updateFrequencyLabel(product) {
    if (product.selling_plan_groups.length > 0) {
      frequencyLabel.style.display = 'block';
      frequencySubheading.style.display = 'block';
      orderNowFormSubscription.style.display = 'block';
    } else {
      frequencyLabel.style.display = 'none';
      frequencySubheading.style.display = 'none';
      orderNowFormSubscription.style.display = 'none';
    }
  }

  // Function to update the progress bar steps
  function updateProgressBar(step) {
    progressBarSteps.forEach(function (progressStep) {
      let stepNumber = parseInt(progressStep.getAttribute('data-step'));
      if (stepNumber < step) {
        progressStep.classList.add('completed');
        progressStep.classList.remove('active');
      } else if (stepNumber === step) {
        progressStep.classList.add('active');
        progressStep.classList.remove('completed');
      } else {
        progressStep.classList.remove('active', 'completed');
      }
    });
  }

  function updateRechargeWidget(variant) {
    // console.log(variant);
    const orderNowForm = document.getElementById('order-now-form');
    if (orderNowForm) {
      const variantInput = orderNowForm.querySelector('input[name="id"]');
      if (variantInput) {
        // Update the input value with the new variant ID
        variantInput.setAttribute('data-productid', selectedProductId);
        variantInput.value = variant.id;
      }

      const rechargeWidget = orderNowForm.querySelector('sms-recharge-widget');
      if (rechargeWidget) {
        // Update the variantId attribute of the recharge widget
        rechargeWidget.setAttribute('variantId', variant.id);

        setTimeout(() => {
          const subscriptionRadio = rechargeWidget.querySelector('input[type="radio"][value="subscriptions"]');
          const oneTimeRadio = document.querySelector('input[type="radio"][value="one-time-purchase"]');
          if (subscriptionRadio) {
            subscriptionRadio.checked = true;
            subscriptionRadio.dispatchEvent(new Event('change'));
          }

          if (subscriptionRadio) {
            subscriptionRadio.addEventListener('change', function () {
              if (this.checked) {
                // Show all subscription price containers, hide all one-time price containers
                document
                  .querySelectorAll('.servings-price-container.subscription')
                  .forEach((el) => el.classList.remove('hidden'));
                document
                  .querySelectorAll('.servings-price-container.one-time')
                  .forEach((el) => el.classList.add('hidden'));
              }
            });
          }
          if (oneTimeRadio) {
            oneTimeRadio.addEventListener('change', function () {
              if (this.checked) {
                // Hide all subscription price containers, show all one-time price containers
                document
                  .querySelectorAll('.servings-price-container.subscription')
                  .forEach((el) => el.classList.add('hidden'));
                document
                  .querySelectorAll('.servings-price-container.one-time')
                  .forEach((el) => el.classList.remove('hidden'));
              }
            });
          }
        }, 100);
      }
    }
  }

  function initRechargeWidget(product) {
    let widgetContainer = document.getElementById('order-now-form-subscription');
    widgetContainer.innerHTML = '';
    let rechargeWidget = document.createElement('sms-recharge-widget');

    // Set the class attribute
    rechargeWidget.className = 'recharge-widget-instance';

    // Set the data attributes
    rechargeWidget.setAttribute('productId', product.id);
    rechargeWidget.setAttribute('variantId', selectedVariant.id);

    // Append the element to a widget container
    widgetContainer.appendChild(rechargeWidget);
  }

  // Event listeners for month selector buttons
  document.getElementById('current-month-btn').addEventListener('click', function () {
    if (currentMonthProduct && selectedProductId !== currentMonthProduct.id) {
      populateMenuSelector(currentMonthProduct, currentMonthSeasonalProduct, 'current');
      displayVariants(currentMonthProduct.id, currentMonthProduct.variants[0].option1);
      updateProgressBar(1); // Move back to step 1 on month change
      initRechargeWidget(currentMonthProduct);
      updateFrequencyLabel(currentMonthProduct);
      removeActiveClass('month-btn');
      this.classList.add('active');
    }
  });

  document.getElementById('next-month-btn').addEventListener('click', function () {
    if (nextMonthProduct && selectedProductId !== nextMonthProduct.id) {
      populateMenuSelector(nextMonthProduct, nextMonthSeasonalProduct, 'next');
      displayVariants(nextMonthProduct.id, nextMonthProduct.variants[0].option1);
      updateProgressBar(1); // Move back to step 1 on month change
      initRechargeWidget(nextMonthProduct);
      updateFrequencyLabel(nextMonthProduct);
      removeActiveClass('month-btn');
      this.classList.add('active');
    }
  });

  // Initialize the page with default product and menu option
  initializePage();

  function handleAddToCart(event) {
  // If cart type is "page", use a native form POST so the theme won't open the drawer.
  if (cartType === 'page') {
    event.preventDefault();

    // Ensure the form points to /cart/add and will redirect to /cart
    addToCartForm.action = '/cart/add';
    addToCartForm.method = 'post';

    // Make sure the variant input is set to the currently selected variant
    const idInput = addToCartForm.querySelector('input[name="id"]');
    if (idInput && selectedVariant) {
      idInput.value = selectedVariant.id;
      idInput.setAttribute('data-productid', selectedProductId);
    }

    // Clean up inputs to match your existing JSON logic:
    // remove any purchase-option inputs; strip selling_plan if one-time is selected
    Array.from(addToCartForm.querySelectorAll('input[name]')).forEach((inp) => {
      const name = inp.getAttribute('name') || '';
      if (name.includes('purchase-option')) {
        inp.remove(); // don't send purchase-option inputs
      }
    });

    // If one-time purchase is selected, remove selling_plan inputs
    const oneTimeRadio = addToCartForm.querySelector('input[type="radio"][value="one-time-purchase"]');
    if (oneTimeRadio && oneTimeRadio.checked) {
      Array.from(addToCartForm.querySelectorAll('input[name="selling_plan"]')).forEach((inp) => inp.remove());
    }

    // Ensure quantity input exists
    let qtyInput = addToCartForm.querySelector('input[name="quantity"]');
    if (!qtyInput) {
      qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = 'quantity';
      qtyInput.value = '1';
      addToCartForm.appendChild(qtyInput);
    }

    // Add return_to so Shopify server redirects to /cart automatically
    let rt = addToCartForm.querySelector('input[name="return_to"]');
    if (!rt) {
      rt = document.createElement('input');
      rt.type = 'hidden';
      rt.name = 'return_to';
      addToCartForm.appendChild(rt);
    }
    rt.value = '/cart';

    // Native submit → no drawer JS runs
    addToCartForm.submit();
    return;
  }

  // ---- Drawer mode (AJAX) ----
  event.preventDefault();
  updateProgressBar(4);

  const formData = new FormData(addToCartForm);
  const jsonData = Object.fromEntries(formData.entries());

  // Match your existing cleanup for AJAX path
  for (const key in jsonData) {
    if (key.includes('purchase-option')) {
      delete jsonData[key];
    }
    const oneTime = document.querySelector('input[type="radio"][value="one-time-purchase"]');
    if (oneTime && oneTime.checked && key.includes('selling_plan')) {
      delete jsonData[key];
    }
  }

  if (selectedVariant) {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        const existingItem = cart.items.find(
          (item) =>
            item.variant_id === selectedVariant.id &&
            ((item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id) || '') ===
              (jsonData.selling_plan || '')
        );

        if (existingItem) {
          // use your existing helper
          updateCartItem(`${existingItem.id}`, existingItem.quantity + 1);
        } else {
          addItemToCart(jsonData); // use your existing helper
        }
      })
      .catch((err) => console.error('Error fetching cart:', err));
  }
}

  function addItemToCart(data) {
    console.log('Adding item to cart:', data);
    isAddingFromOrderNow = true; // Set flag
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        // The theme:cart:added event will handle the behavior based on cart type
        // If drawer is enabled, it will open automatically
        // If drawer is disabled, the event listener will redirect to cart page
      })
      .catch((error) => {
        console.error('Error adding to cart:', error);
        isAddingFromOrderNow = false; // Reset flag on error
      });
  }

  function updateCartItem(lineItemId, newQuantity) {
    isAddingFromOrderNow = true; // Set flag
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: lineItemId,
        quantity: newQuantity,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        // Cart updates might not trigger theme:cart:added event
        // Handle based on cart type
        if (cartType === 'page') {
          window.location = '/cart';
        } else {
          // If drawer is enabled, open it
          if (window.theme && window.theme.cart && window.theme.cart.openCartDrawer) {
            window.theme.cart.openCartDrawer();
          } else {
            window.location = '/cart';
          }
        }
      })
      .catch((error) => {
        console.error('Error updating cart:', error);
        isAddingFromOrderNow = false; // Reset flag on error
      });
  }

  function removeCartItem(lineItemId) {
    // Send AJAX request to Shopify API to remove item from cart
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        line: Number(lineItemId) - 1,
        quantity: 0,
        sections: 'order-now-cart-section',
        sections_url: '/pages/order-now',
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Cart updated:', data);
        // Update the cart UI here (e.g., reload cart items, update totals)
        document.getElementById('cart-contents').innerHTML = data.sections['order-now-cart-section']
          ? data.sections['order-now-cart-section']
          : '';

        document.querySelectorAll('.cart__item__remove').forEach((button) => {
          button.addEventListener('click', function (event) {
            event.preventDefault();
            const lineItemId = button.getAttribute('data-id');
            removeCartItem(lineItemId);
          });
        });

        if (window.innerWidth < 768) {
          const continueShoppingButton = document.getElementById('continue-shopping');
          continueShoppingButton.addEventListener('click', function (event) {
            event.preventDefault();
            cartPart.style.display = 'none';
            productPart.style.display = 'block';
            window.scrollTo({ top: 0, behavior: 'smooth' });
          });
        }
      })
      .catch((error) => {
        console.error('Error removing cart item:', error);
      });
  }

  // Keep progress bar and cart section sticky
  function toggleStickyProgressBar() {
    const orderNowSectionTop = orderNowSection.getBoundingClientRect().top;

    if (orderNowSectionTop <= 0) {
      progressBarContainer.classList.add('sticky');
    } else {
      progressBarContainer.classList.remove('sticky');
    }
  }
  window.addEventListener('scroll', toggleStickyProgressBar);

  // Version 2
  setTimeout(() => {
    const widgetContainer = document.getElementById('order-now-form-subscription');
    const subscriptionRadio = widgetContainer.querySelector('input[type="radio"][value="subscriptions"]');
    const oneTimeRadio = widgetContainer.querySelector('input[type="radio"][value="one-time-purchase"]');
    if (subscriptionRadio) {
      subscriptionRadio.checked = true;
      subscriptionRadio.dispatchEvent(new Event('change'));
    }

    if (subscriptionRadio) {
      subscriptionRadio.addEventListener('change', function () {
        if (this.checked) {
          // Show all subscription price containers, hide all one-time price containers
          document
            .querySelectorAll('.servings-price-container.subscription')
            .forEach((el) => el.classList.remove('hidden'));
          document.querySelectorAll('.servings-price-container.one-time').forEach((el) => el.classList.add('hidden'));
        }
      });
    }
    if (oneTimeRadio) {
      oneTimeRadio.addEventListener('change', function () {
        if (this.checked) {
          // Hide all subscription price containers, show all one-time price containers
          document
            .querySelectorAll('.servings-price-container.subscription')
            .forEach((el) => el.classList.add('hidden'));
          document
            .querySelectorAll('.servings-price-container.one-time')
            .forEach((el) => el.classList.remove('hidden'));
        }
      });
    }
  }, 3000);

  // Use MutationObserver to wait for the radio input to appear, then attach listeners
  const widgetContainer = document.getElementById('order-now-form-subscription');
  const observer = new MutationObserver(() => {
    const radioInput = widgetContainer.querySelector('.sms-rw__radio-label-input');
    if (radioInput) {
      // Attach event listeners for toggling price containers
      const subscriptionRadio = widgetContainer.querySelector('input[type="radio"][value="subscriptions"]');
      const oneTimeRadio = widgetContainer.querySelector('input[type="radio"][value="one-time-purchase"]');
      if (subscriptionRadio) {
        subscriptionRadio.addEventListener('change', function () {
          if (this.checked) {
            document
              .querySelectorAll('.servings-price-container.subscription')
              .forEach((el) => el.classList.remove('hidden'));
            document.querySelectorAll('.servings-price-container.one-time').forEach((el) => el.classList.add('hidden'));
          }
        });
      }
      if (oneTimeRadio) {
        oneTimeRadio.addEventListener('change', function () {
          if (this.checked) {
            document
              .querySelectorAll('.servings-price-container.subscription')
              .forEach((el) => el.classList.add('hidden'));
            document
              .querySelectorAll('.servings-price-container.one-time')
              .forEach((el) => el.classList.remove('hidden'));
          }
        });
      }
      observer.disconnect();
    }
  });
  observer.observe(widgetContainer, { childList: true, subtree: true });
});
